import React, { useMemo } from 'react';
import AssetsAudiobook from './assets-audiobook';
import AssetsEbook from './assets-ebook';
import AssetsPaperback from './assets-paperback';

function Assets({ height, type, color }) {
  const assetIcon = useMemo(() => {
    switch (type) {
      case 'ebook':
        return AssetsEbook;
      case 'audiobook':
        return AssetsAudiobook;
      case 'print':
        return AssetsPaperback;
      default:
        return AssetsEbook;
    }
  }, [type]);

  return (
    <svg height={height} viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg" fill={color}>
      {assetIcon}
    </svg>
  );
}

export default Assets;
